import { render, staticRenderFns } from "./BundleShared.vue?vue&type=template&id=7d3b0d36"
import script from "./BundleShared.vue?vue&type=script&lang=js"
export * from "./BundleShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports